import gql from "graphql-tag";
export const BUSINESS_MODELS = gql`
  query businessModelsInfo {
    businessModels {
      edges {
        node {
          id
          name
          code
          commission
          zeroSellPrice
          setAsOptional
          includesFlagOn
          createPI
          editableFlags
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/gt/itineraries/builder/graphql.js